import { handleNYCase } from "./handleNYCase.js";
import { formatPostalCode } from "./formatPostalCode.js";
const isFormatAddressProps = (addr) => "cityReplacement" in addr, formatAddress__ = (addr) => {
  let cityReplacement = "", city = "", streetAddress = "", borough = "", neighborhood = "", state = "", postalCode = "", country = "";
  if (isFormatAddressProps(addr))
    cityReplacement = addr.cityReplacement, city = cityReplacement ?? addr.city, streetAddress = addr.streetAddress, state = addr.state, postalCode = formatPostalCode(addr.postalCode), country = addr.country;
  else {
    const {
      city: city_
    } = addr;
    neighborhood = addr.neighborhood ?? void 0, borough = addr.borough ?? void 0, cityReplacement = handleNYCase({ state: addr.state, neighborhood, borough }), city = cityReplacement ?? city_ ?? void 0, streetAddress = addr.address1 ?? void 0, state = addr.state ?? void 0, postalCode = addr.formattedPostalCode ?? void 0, country = addr.country ?? void 0;
  }
  const stateAndPostal = [state, postalCode == null ? void 0 : postalCode.split("-")[0]].filter(Boolean).join(" ");
  return { formattedAddress: [
    streetAddress,
    city,
    cityReplacement ? "" : borough,
    stateAndPostal,
    country
  ].filter(Boolean).join(", "), cityReplacement };
};
export {
  formatAddress__,
  isFormatAddressProps
};
//# sourceMappingURL=formatAddress__.js.map
